/**
 * Loads JPEG/PNG/WebP from src/images/front_page (sorted by filename, numeric-aware).
 * When the folder is empty, uses Firebase URLs as fallback.
 */
const FALLBACK_SLIDES = [
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/weddingstoriess-person.appspot.com/o/home-carousel%2Fl5.jpg?alt=media&token=4c3ff581-4232-4786-8fd8-456c22a32c3a',
    alt: 'Wedding photography',
  },
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/weddingstoriess-person.appspot.com/o/home-carousel%2FDSC02660m.jpg?alt=media&token=5ce7c886-d97d-42ba-8b4a-eade318ebdbd',
    alt: 'Wedding photography',
  },
];

function sortCarouselKeys(keys) {
  return [...keys].sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
  );
}

function getFrontCarouselSlides() {
  const ctx = require.context(
    '../images/front_page',
    false,
    /\.(jpe?g|png|webp)$/i
  );
  const keys = sortCarouselKeys(ctx.keys());
  if (keys.length === 0) {
    return FALLBACK_SLIDES;
  }
  return keys.map((key) => ({
    src: ctx(key),
    alt: 'Wedding photography',
  }));
}

export default getFrontCarouselSlides;
